import React from "react";
import { Logo } from "./Logo";
import { footer } from "../mock";

const Footer = () => {
  return (
    <footer className="w-full shrink-0 border-t border-slate-100 bg-white">
      <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-2 px-6 py-3 sm:flex-row lg:px-8">
        <div className="flex items-center gap-4">
          <Logo size={40} />
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
          {footer.links.map((link) => (
            <a
              key={link}
              href={`#${link.toLowerCase()}`}
              className="text-[14px] font-medium text-slate-700 transition-colors hover:text-[#1E4FA3]"
            >
              {link}
            </a>
          ))}
        </nav>
        <p className="hidden text-[12px] text-slate-500 lg:block">{footer.tagline}</p>
      </div>
    </footer>
  );
};

export default Footer;
